import { ProtectionLevel } from './protection-level';
import { ProtectionPricingCard } from './protection-pricing-card';

export class AppliedProtectionPrice {
	level: ProtectionLevel;
	card: ProtectionPricingCard | null;
	isDefault: boolean;
}
